import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import '@/index.css'
import { HomePage } from '@/pages/HomePage'

// Code-split the privacy route so it isn't in the main bundle.
const PrivacyPage = lazy(() =>
  import('@/pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage }))
);

// Unlinked web version of the app, for testing only (noindex).
const WebAppPage = lazy(() =>
  import('@/pages/WebAppPage').then((m) => ({ default: m.WebAppPage }))
);

// Hidden colour-theme testing page.
const ThemeLabPage = lazy(() =>
  import('@/pages/ThemeLabPage').then((m) => ({ default: m.ThemeLabPage }))
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/privacy",
    element: (
      <Suspense fallback={<div className="min-h-screen bg-[#FEF7FF] dark:bg-m3-dark-surface" />}>
        <PrivacyPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/app",
    element: (
      <Suspense fallback={<div className="min-h-screen bg-[#FEF7FF] dark:bg-m3-dark-surface" />}>
        <WebAppPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/themes",
    element: (
      <Suspense fallback={<div className="min-h-screen bg-[#FEF7FF] dark:bg-m3-dark-surface" />}>
        <ThemeLabPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
)
   
